import { Result } from 'domain/types';
import ReadWidgetClient from 'use-case/widget/read/readWidgetClient';
import ReadWidgetCriteria from 'use-case/widget/read/readWidgetCriteria';
import Widget from 'domain/entity/widget';

export type ReadWidgetResult = Result<Widget>;
export type ReadWidget = (criteria: ReadWidgetCriteria) => Promise<ReadWidgetResult>;

export default (readWidgetClient: ReadWidgetClient): ReadWidget => (criteria: ReadWidgetCriteria): Promise<ReadWidgetResult> =>
    readWidgetClient(criteria);
